const module = { name: 'layouts/desktop.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { default as deferImages } from 'swug-fdRequire-call:global/jcarousel.deferImages';



import { default as detectTouch } from 'swug-fdRequire-call:shared/global/detectTouch';



import { default as getZip } from 'swug-fdRequire-call:desktop/global/getZip';



import { default as localeDetector } from 'swug-fdRequire-call:fd-location/localeDetector';



import { default as offerBanner } from 'swug-fdRequire-call:shared/global/offerBanner';



import { default as regionSelector } from 'swug-fdRequire-call:fd-location/regionSelector';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { global_tracking_passiveEvents as passiveEvents } from 'require-global';



import { default as responsiveAds } from 'swug-fdRequire-call:shared/global/responsiveAds';



import { default as share } from 'swug-fdRequire-call:Fandango/share';



import { default as swInstall } from 'swug-fdRequire-call:desktop/shared/sw-install';



const Selectors = {
    LOCAL_MOVIES_LINK: '#local-movies-link',
    OFFER_MODAL_CTA: '.js-offer-modal-cta',
}
function initOffersModal() {
    modal.offers(Selectors.OFFER_MODAL_CTA);
}
function initCookieDefaults() {
    $.cookie.defaults.domain = '.fandango.co.uk';
    $.cookie.defaults.path = '/';
    $.cookie.defaults.expires = 365;
}
function run() {
    checkDependencies(module.name, debugLog);
    initCookieDefaults();
    initOffersModal();
    xhr.init({
        tokenURI: links.napiAccountThemePreferences(),
        isMobile: false,
        timeout: 15000,
    });
    responsiveAds.init();
    deferImages.init();
    detectTouch.init();
    getZip.init(Selectors.LOCAL_MOVIES_LINK);
    passiveEvents.attach();
    share.init();
    swInstall.onLoadInitServiceWorker();
    offerBanner.init();
    regionSelector.init();
    localeDetector.init();
}
run();
export default module.exports;